import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchEnterpriseProducts = async (enterpriseId, params) => api.request(1, `/api/v3/enterprise/${enterpriseId}/products/`, MethodType.GET, params)
